<!--@description 封装全局缺货弹窗
    @author cc
    @date 2020-3-12
  -->
<template>
  <div>
    <cc-bottom-popup
      :autoHeight="true"
      v-bind="$attrs"
      v-on="$listeners"
      title="预订商品"
      @closeCallback="closeCallback"
      @subBtn="subBtn">
      <!-- 内容 -->
      <div class="nogoods-con-center">
        <van-field
          v-model="num"
          placeholder="预订数量"
          class="nogoods-con-center-input"
          :clearable="true"
        />
        <van-checkbox v-model="checked" class="nogoods-con-center-checkbox">缺货提醒</van-checkbox>
      </div>
    </cc-bottom-popup>
  </div>
</template>
<script>
import Vue from 'vue'
import { Field, Checkbox, Toast } from 'vant'
import { remindGoods } from '@/fetch/common/index.js'
Vue.use(Field).use(Checkbox).use(Toast)
export default {
  name: 'CcNogoodsRemind',
  props: {
    // 商品数据
    cartItem: {
      type: Object
    },
    // // 显示隐藏
    NogoodShow: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      num: '',
      checked: true
    }
  },
  created () {
  },
  methods: {
    /**
     * @description 缺货提醒
     * @author cc
     * @date 2020-3-7
     * @param {id:1}
     * @export
     */
    async subBtn () {
      if (this.num === '' && this.checked === false) {
        Toast('请填写预订数量或勾选缺货提醒')
      } else {
        var params = { goods_id: this.cartItem.id || this.cartItem.goods_id, is_remind: this.checked === true ? '1' : '0', num: this.num }
        let res = await remindGoods(params)
        if (res.status === 0) {
          // 请求成功
          Toast(res.info.msg)
          // 关闭弹窗
          this.$emit('close')
        } else {
          // 请求失败
          Toast(res.info.msg)
        }
      }
    },
    closeCallback () {
      this.num = ''
      this.checked = true
    }
  }
}
</script>
<style lang="scss" scoped>
.nogoods-con {
  height: 100%;
  &-center {
    height: 320px;
    padding: 0 10px;
    // border-bottom: 1px solid #e5e5e5;
    &-input {
      background: #f7f6f6;
      height: 40px;
      margin-top: 10px;
      border-radius: 4px;
    }
    &-checkbox {
      margin-top: 10px;
      /deep/ {
        .van-checkbox__icon--checked .van-icon {
          background: var(--APP_theme_color);
          border-color: var(--APP_theme_color);
        }
      }
    }
  }
}
</style>
